// @flow
import React, {useMemo} from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import {muiGridLocales} from "../../../../../../../helpers/muiGridLocales";
import {DataGridPremium, GridToolbar, useGridApiRef, useKeepGroupedColumnsHidden} from "@mui/x-data-grid-premium";
import {formatDate} from "../../../../../../../helpers/date";
import dayjs from "dayjs";
import { reportGridsSx } from "../../helpers";

type Props = {};

const VisitsHalfHour = (props: Props) => {
	const {loading, data, t, generalReport} = props
	const {language, dateFormat} = useUserData()
	
	const apiRef = useGridApiRef();
	const initialState = useKeepGroupedColumnsHidden({
		apiRef,
		initialState: {
			density: "standard",
			rowGrouping: {
				model: generalReport ? ['groupingColumn'] : ['exhibitionStartDt']
			},
		},
	});
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'groupingColumn',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				width: 800,
			}] : []),
			...(!generalReport ? [{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				width: 280,
				valueFormatter: (value, row, column, apiRef) => {
					return `${formatDate(value, dateFormat)}`
				}
			}] : []),
			{
				field: 'entranceDate',
				description: t('Entrance Date'),
				headerName: t('Entrance Date'),
				flex: 1,
				minWidth: 180,
				valueFormatter: (value, row, column, apiRef) => {
					return (value ? dayjs(value).format(dateFormat) : '')
				}
			},
			{
				field: 'entranceTime',
				description: t('Entrance Time'),
				headerName: t('Entrance Time'),
				flex: 1,
				minWidth: 180,
				valueFormatter: (value, row, column, apiRef) => {
					if (value) {
						const toArray = value.split(':')
						return value && toArray.length > 1 ? dayjs().hour(toArray[0]).minute(toArray[1]).format('HH:mm') : ''
					}
					return ''
				}
			},
			{
				field: 'entranceLobby1Count',
				description: t('EntranceLobby1Count'),
				headerName: t('EntranceLobby1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceLobby2Count',
				description: t('EntranceLobby2Count'),
				headerName: t('EntranceLobby2Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceLoungeCount',
				description: t('EntranceLoungeCount'),
				headerName: t('EntranceLoungeCount'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent1Count',
				description: t('EntranceEvent1Count'),
				headerName: t('EntranceEvent1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent2Count',
				description: t('EntranceEvent2Count'),
				headerName: t('EntranceEvent2Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent3Count',
				description: t('EntranceEvent3Count'),
				headerName: t('EntranceEvent3Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent4Count',
				description: t('EntranceEvent4Count'),
				headerName: t('EntranceEvent4Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent5Count',
				description: t('EntranceEvent5Count'),
				headerName: t('EntranceEvent5Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceCount',
				description: t('Entrance Count'),
				headerName: t('Entrance Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'visitorCount',
				description: t('VisitorCount'),
				headerName: t('VisitorCount'),
				flex: 1,
				minWidth: 220,
				type: 'number',
			},
		],
		[dateFormat, t, generalReport]
	)
	
	return (
		<Box style={{height: 600, width: '100%'}}>
			<DataGridPremium
				sx={reportGridsSx}
				apiRef={apiRef}
				// sx={{bgcolor: 'background.paper'}}
				loading={loading}
				initialState={initialState}
				localeText={muiGridLocales(language)}
				rows={data}
				columns={columns}

				slots={{
					toolbar: GridToolbar,
				}}
				slotProps={{toolbar: {csvOptions: {disableToolbarButton: true}}}}
				defaultGroupingExpansionDepth={-1}
			/>
		</Box>
	);
};

export default VisitsHalfHour